/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface CreateLeadWaitlistUpdate201Response
 */
export interface CreateLeadWaitlistUpdate201Response {
    /**
     * 
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner;
}

/**
 * Check if a given object implements the CreateLeadWaitlistUpdate201Response interface.
 */
export function instanceOfCreateLeadWaitlistUpdate201Response(value: object): value is CreateLeadWaitlistUpdate201Response {
    return true;
}

export function CreateLeadWaitlistUpdate201ResponseFromJSON(json: any): CreateLeadWaitlistUpdate201Response {
    return CreateLeadWaitlistUpdate201ResponseFromJSONTyped(json, false);
}

export function CreateLeadWaitlistUpdate201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadWaitlistUpdate201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON(json['data']),
    };
}

export function CreateLeadWaitlistUpdate201ResponseToJSON(json: any): CreateLeadWaitlistUpdate201Response {
    return CreateLeadWaitlistUpdate201ResponseToJSONTyped(json, false);
}

export function CreateLeadWaitlistUpdate201ResponseToJSONTyped(value?: CreateLeadWaitlistUpdate201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON(value['data']),
    };
}

